export default "__VITE_ASSET__aaae5d0f__"